import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => createStyles({
    gray: {
        borderColor: theme.palette.grey[500],
        color: `${theme.palette.grey[500]} !important`,
        backgroundColor: 'white',
        transition: 'background-color 200ms',
        '&:hover': {
            backgroundColor: `${theme.palette.grey[100]} !important`,
            borderColor: `${theme.palette.grey[500]} !important`,
        }
    },
    primary: {}
}));

export default function({ color, variant, onClick, children }) {
    const classes = useStyles();
    let className = 'primary';
    if (color === 'gray') {
        color = 'primary';
        className = 'gray';
    }

    return (
        <IconButton
            onClick={onClick}
            className={classes[className]}
            variant={variant}
            color={color}
        >
            {children}
        </IconButton>
    );
}